<template>
  <div class="user-menu">
    <div class="user-avatar" @click="toggleUserMenu">
      {{ initials }}
    </div>
    <div 
      class="user-menu-wrapper" 
      v-if="userMenuVisible" 
      @click.stop
    >
      <div class="user-menu-content">
        <a class="user-menu-item" :href="`/users/${currentUser.id}`">
          <font-awesome-icon :icon="['fas', 'user']" />
          {{ $t("profile") }}
        </a>
        <a class="user-menu-item" href="/logout">
          <font-awesome-icon :icon="['fas', 'right-from-bracket']" />
          {{ $t("logout") }}
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    currentUser: {
      type: Object,
      default: () => ({ first_name: "", last_name: "" })
    }
  },
  data() {
    return {
      userMenuVisible: false
    };
  },
  computed: {
    initials() {
      const firstInitial = this.currentUser.first_name?.[0] || "";
      const lastInitial = this.currentUser.last_name?.[0] || "";
      return (firstInitial + lastInitial).toUpperCase();
    }
  },
  mounted() {
    document.addEventListener("click", this.closeDropdown);
  },
  beforeDestroy() {
    document.removeEventListener("click", this.closeDropdown);
  },
  methods: {
    toggleUserMenu() {
      this.userMenuVisible = !this.userMenuVisible;
    },
    closeDropdown(event) {
      if (!this.$el.contains(event.target)) {
        this.userMenuVisible = false;
      }
    }
  }
};
</script>

<style scoped>
.user-menu {
  position: relative;
  display: inline-block;
}

.user-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: #8c8ce9;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
  user-select: none;
}

.user-menu-wrapper {
  display: inline-block;
  position: fixed;
  z-index: 2000;
  right: 30px;
  top: 70px;
  border-radius: 15px;
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.25);
}

.user-menu-content {
  background: #ffffff;
  border: 1px solid #c1c1c1;
  width: 200px;
  border-radius: 15px;
  padding: 5px 0;
}

.user-menu-item {
  padding: 8px 16px;
  margin: 5px;
  border-radius: 15px;
  color: #333;
  text-decoration: none;
  display: block;
  cursor: pointer;
  transition: 0.2s;
}

.user-menu-item:hover {
  background-color: #f7f6f6;
}

.user-menu-item svg {
  margin-right: 15px;
}
</style>
